var $674a91b46322906c$exports = {};
$674a91b46322906c$exports = {
    "pending": `\u{5F85}\u{8655}\u{7406}`
};


export {$674a91b46322906c$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
